module.exports = __webpack_public_path__ + "img/user.a9bb846b.svg";